import React from 'react';

import ArticleListingItem from '$partials/items/article-listing-item';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ArticleSplitColumns}
 */
const ArticleSplitColumns = ({ items }) => {
    const chunkArray = (array, size) => {
        const chunkedArray = [];
        for (let i = 0; i < array.length; i += size) {
            chunkedArray.push(array.slice(i, i + size));
        }
        return chunkedArray;
    };

    const chunkedItems = chunkArray(items, 4);

    return (
        <div className='flex gap-y-8 md:gap-y-16 flex-col'>
            {chunkedItems.map((group, idx) => {
                return (
                    <div
                        className={`grid md:-mx-8 gap-y-8 sm:gap-y-0 sm:grid-cols-2 gap-x-8 md:gap-0 ${idx % 2 === 0 ? 'md:grid-cols-2-1' : 'md:grid-cols-1-2'}`}
                        key={`article-split-column-${idx}`}>
                        {/* Left */}
                        <article className={`${idx % 2 === 0 ? '' : 'order-1'} sm:sticky sm:top-8 md:top-16 h-fit md:px-8`}>
                            <ArticleListingItem
                                orientation='horizontal'
                                {...group.slice(0, 1)[0]}/>
                        </article>

                        {/* Right */}
                        <div className={`${idx % 2 === 0 ? 'order-1' : ''} flex flex-col gap-y-8 md:gap-y-16 md:px-8`}>
                            {group.slice(1)?.map(item => {
                                return (
                                    <article key={item.id}>
                                        <ArticleListingItem {...item}/>
                                    </article>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArticleSplitColumns;
